import {
	addProductLang,
	createProduct,
	deleteManyProduct,
	deleteProductLang,
	getProduct,
	getProducts,
	getProductSegments,
	updateProduct,
	updateProductLang,
} from "@/api/products";
import { useQuery, useMutation } from "@tanstack/react-query";
import { CreateEditProductPayload, ProductTranslationPayload } from "../types";

export const useGetProducts = (
	enabled: boolean,
	filter: Record<string, string | boolean | number>,
	withPagination = true
) => {
	return useQuery({
		queryKey: ["products", filter],
		queryFn: () => getProducts(filter, withPagination),
		enabled,
	});
};

export const useGetProduct = (id: number) => {
	return useQuery({
		queryKey: ["getProduct", id],
		queryFn: () => getProduct(id),
		enabled: id > 0,
	});
};

export const useDeleteManyProduct = () => {
	return useMutation({
		mutationFn: ({ ids }: { ids: number[] }) => deleteManyProduct(ids),
	});
};

export const useUpdateProductLang = () => {
	return useMutation({
		mutationFn: (payload: ProductTranslationPayload) => updateProductLang(payload),
	});
};

export const useAddProductLang = () => {
	return useMutation({
		mutationFn: (payload: ProductTranslationPayload) => addProductLang(payload),
	});
};

export const useDeleteProductLang = () => {
	return useMutation({
		mutationFn: ({ productId, locale }: { productId: number; locale: string }) => deleteProductLang(productId, locale),
	});
};

export const useGetProductSegments = () => {
	return useQuery({
		queryKey: ["product-segments"],
		queryFn: () => getProductSegments(),
	});
};

export const useCreateProduct = () => {
	return useMutation({
		mutationFn: (payload: CreateEditProductPayload) => createProduct(payload),
	});
};

export const useUpdateProduct = () => {
	return useMutation({
		mutationFn: ({ id, payload }: { id: number; payload: CreateEditProductPayload }) => updateProduct(id, payload),
	});
};
